export const UPDATE_CONSENT_TEXT = 'update_consent_text'
export const SIGN_CONSENT = 'sign_consent'
export const UPDATE_CONSENT_PATIENTS = 'update_consent_patients'
export const RESET_CONSENT_STATE = 'reset_consent_state'

export const initialConsentState: ConsentState = {
  consentText: '',
  isConsentSigned: false,
  patients: [],
}
